import { Link } from "react-router-dom";
import { SERVICES } from "../data/services";
import { LogoMark } from "./Logo";
import { ExtLink } from "./Bits";

const Col = ({ title, links, id }) => (
  <div>
    <h2 className="eyebrow mb-4 text-mist" id={id}>{title}</h2>
    <ul className="space-y-1" aria-labelledby={id}>
      {links.map((l) => (
        <li key={l.to}><Link to={l.to} className="link-u inline-flex min-h-[36px] items-center text-sm text-ink" data-testid={`footer-link-${l.to.split("/").pop() || "home"}`}>{l.label}</Link></li>
      ))}
    </ul>
  </div>
);

const guides = [
  { label: "Repair or replace guide", to: "/guides/repair-vs-replace" },
  { label: "Furnace symptom guide", to: "/guides/furnace-symptoms" },
  { label: "Furnace cost factors", to: "/guides/furnace-cost-factors" },
  { label: "Answer Hub", to: "/answer-hub" },
];
const company = [
  { label: "All services", to: "/services" },
  { label: "Service area", to: "/service-area" },
  { label: "Illustrative work", to: "/illustrative-work" },
  { label: "Contact (demo form)", to: "/contact" },
];
const gov = [
  { label: "About this demonstration", to: "/about-this-demonstration" },
  { label: "Privacy policy", to: "/privacy-policy" },
  { label: "Terms of use", to: "/terms-of-use" },
  { label: "Accessibility statement", to: "/accessibility-statement" },
];

export const Footer = () => (
  <footer className="bg-tan text-ink" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-5 pb-10 pt-20 sm:px-8">
      <div className="grid gap-12 lg:grid-cols-[1.3fr_repeat(4,1fr)]">
        <div>
          <Link to="/" className="flex items-center gap-3" aria-label="Denver Furnace Repair demonstration home" data-testid="footer-logo-link">
            <LogoMark className="h-10 w-10" />
            <span className="font-display text-2xl font-semibold uppercase tracking-tight">Denver Furnace Repair</span>
          </Link>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-mist">
            A VisibilityReady™ demonstration of a diagnosis-first furnace contractor website for the Denver metro. Not an operating business. No services are offered or sold here.
          </p>
        </div>
        <Col title="Services" id="f-services" links={SERVICES.map((s) => ({ label: s.short, to: s.path }))} />
        <Col title="Guides" id="f-guides" links={guides} />
        <Col title="Explore" id="f-explore" links={company} />
        <Col title="Governance" id="f-gov" links={gov} />
      </div>

      <div className="mt-16 grid gap-6 rounded-2xl border border-gold/50 bg-emerald-vr p-6 text-bone sm:p-8 md:grid-cols-[auto_1fr_auto] md:items-center" data-testid="visibilityready-attribution">
        <img src="/assets/images/visibilityready-favicon-32x32.png" width="32" height="32" alt="" className="h-8 w-8" />
        <div>
          <p className="font-display text-xl uppercase tracking-tight">VisibilityReady™ Demonstration</p>
          <p className="text-sm text-bone/90">Developed Exclusively By Fat Wallet Internet Marketing</p>
        </div>
        <ExtLink testid="footer-cta-external" className="btn-gold">See VisibilityReady™ demonstrations</ExtLink>
      </div>

      <div className="mt-10 flex flex-col gap-3 border-t border-line pt-6 text-[0.8rem] text-mist md:flex-row md:justify-between">
        <p data-testid="footer-demo-disclosure">Demonstration disclosure: business details, scenarios, and sample reviews on this site are illustrative. Images are AI-generated or licensed stock scenes, not completed client work.</p>
        <p>© {new Date().getFullYear()} Fat Wallet Internet Marketing</p>
      </div>
    </div>
  </footer>
);
